'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faBook } from '@fortawesome/free-solid-svg-icons'
import React, { ReactNode, useState } from 'react'

interface Props {
  categories: { id: string; name: string; slug: string }[] // Mảng categories với SimpleCategory structure
  onTabChange?: (slug: string) => void
  children: (activeTab: string) => ReactNode
}

const FeatureTabWrapper: React.FC<Props> = ({ categories, onTabChange, children }) => {
  const [activeTab, setActiveTab] = useState(categories[0]?.slug || '')

  const handleTabClick = (slug: string) => {
    setActiveTab(slug)
    onTabChange?.(slug)
  }

  const getIcon = (categorySlug: string) => {
    switch (categorySlug) {
      case 'most-viewed':
        return <FontAwesomeIcon icon={faEye} />
      case 'latest-articles':
        return <FontAwesomeIcon icon={faBook} />
      default:
        return null
    }
  }

  return (
    <div>
      {/* Tabs */}
      <div className="relative flex space-x-0 pb-4 border-b border-gray-300">
        {categories.map((category) => {
          const isActive = activeTab === category.slug
          return (
            <div
              key={category.id}
              className={`cursor-pointer font-medium flex items-center gap-2 px-6 py-3 relative transition-all duration-300 ${
                isActive ? 'text-primary bg-gray-100' : 'text-gray-600 hover:text-primary'
              }`}
              onClick={() => handleTabClick(category.slug)}
            >
              {/* Hiển thị Icon */}
              <div className="text-xl">{getIcon(category.slug)}</div>
              <span className="text-lg">{category.name}</span>

              {/* Border Bottom */}
              <div
                className={`absolute bottom-0 left-0 w-full h-[2px] bg-primary transition-all duration-300 ${
                  isActive ? 'transform scale-x-100' : 'transform scale-x-0'
                }`}
              />
            </div>
          )
        })}
      </div>

      {/* Nội dung tab */}
      <div>{children(activeTab)}</div>
    </div>
  )
}

export default FeatureTabWrapper
